import React, { useEffect, useRef, useState } from "react";
import StatusBadge from "../../components/ui/StatusBadge";
import { useOutletContext, useParams } from "react-router-dom";
import Spinner from "../../components/ui/Spinner";
import ChatBubble from "../../components/ui/ChatBubble";
import { strToFormattedDate } from "../../helpers/formatHelper";
import { useUserContext } from "../../context/userContext";
import { updateProcurement } from "../../services/api/procurementService";
import { cleanQuillHtml, isEditorEmpty } from "../../helpers/editorHelper";
import Editor from "../../components/Editor";
import { toast } from "react-toastify";
import { Button } from "@mui/material";
import SendIcon from '@mui/icons-material/Send';

export default function Comments() {
  const { user } = useUserContext();
  const { uuidProcurement } = useParams();
  const { procurement, handleUpdateProcurement } = useOutletContext();
  const [isLoading] = useState(false);
  const commentsEndRef = useRef(null);
  const [content, setContent] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const quillRef = useRef();

  useEffect(() => {
    if (procurement.comments.length > 0) {
      commentsEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [procurement.comments]);

  async function handleAddComment() {
    if (isEditorEmpty(content)) {
      return;
    }
    try {
      setIsUpdating(true);
      await updateProcurement(uuidProcurement,
        {
          comment: {
            message: cleanQuillHtml(content),
            beNotified: true,
          },
        },
      );
      await handleUpdateProcurement();
      setContent("");
      quillRef.current.setText("");
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsUpdating(false);
    }
  }

  if (isLoading) {
    return (
      <Spinner />
    );
  }

  return (
    <div className="w-full h-full flex flex-col min-h-0">
      <div className="flex flex-col flex-grow space-y-6 min-h-0">
        <div className="p-4 bg-white rounded-lg shadow content-end h-3/5 lg:h-3/4 overflow-y-auto">
          {procurement.comments.length > 0
            ? (
              <>
                <div className="space-y-4">
                  {procurement.comments.map(comment => (
                    <ChatBubble
                      key={comment.uuid}
                      username={comment.user.fullname}
                      date={strToFormattedDate(comment.createdAt, "dd/MM/yyy HH:mm")}
                      message={comment.message}
                      step={comment.step.status}
                      me={user.uuid === comment.user.uuid}
                    />
                  ))}
                </div>
                <div ref={commentsEndRef} />
              </>
            )
            : (
              <div className="place-self-center">
                <StatusBadge text="Aucun commentaire" color="yellow" />
              </div>
            )}
        </div>

        <div className="flex h-2/5 gap-2 lg:h-1/4">
          <div className="flex-grow overflow-hidden">
            <Editor
              ref={quillRef}
              onTextChange={setContent}
            />
          </div>

          <div className="flex self-end items-center space-x-2">
            <Button
              color="primary"
              variant="contained"
              disableElevation
              onClick={handleAddComment}
              loading={isUpdating}
              endIcon={<SendIcon />}
            >
              Envoyer
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
